import { useState } from 'react';
import { disable, enable, getState } from '../utils/desktopNotifications';
import './NotificationToggle.css';

const LABELS = {
  on: 'Desktop alerts on',
  off: 'Desktop alerts off',
  blocked: 'Alerts blocked'
};

// Button that turns desktop alerts on/off for this browser. Hidden where the
// browser has no Notification support.
export default function NotificationToggle() {
  const [state, setState] = useState(getState);
  if (state === 'unsupported') return null;

  const toggle = async () => {
    if (state === 'on') setState(disable());
    else setState(await enable());
  };

  return (
    <button
      type="button"
      className={`notification-toggle is-${state}`}
      aria-pressed={state === 'on'}
      onClick={toggle}
      title={state === 'blocked'
        ? 'Notifications are blocked for this site. Allow them in your browser\'s site settings, then click again.'
        : 'Get a desktop alert for new tickets and customer replies while this tab is in the background.'}
    >
      <i className={`fas ${state === 'on' ? 'fa-bell' : 'fa-bell-slash'}`} aria-hidden="true"></i> {LABELS[state]}
    </button>
  );
}
